import React, { Component } from 'react';
import PropTypes from 'prop-types';

class PopupWrapper extends Component {
  static propTypes = {
    isOpen: PropTypes.bool,
    togglePopup: PropTypes.func,
    className: PropTypes.string,
  };

  constructor(props) {
    super(props);

    this.autoClosePopup = this.autoClosePopup.bind(this);
  }

  componentDidMount = () => {
    window.addEventListener('click', this.autoClosePopup);
  };

  componentWillUnmount() {
    window.removeEventListener('click', this.autoClosePopup);
  }

  autoClosePopup(event) {
    const userHasClickedOutsideOfPopup =
      this.container && !this.container.contains(event.target);
    if (
      this.props.isOpen &&
      this.props.togglePopup &&
      userHasClickedOutsideOfPopup
    ) {
      this.props.togglePopup();
    }
  }

  render() {
    return (
      <span className={this.props.className} ref={el => (this.container = el)}>
        {this.props.children}
      </span>
    );
  }
}

export default  PopupWrapper;
